import { render, staticRenderFns } from "./ChainListCard.vue?vue&type=template&id=13dd26cc"
import script from "./ChainListCard.vue?vue&type=script&lang=ts"
export * from "./ChainListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports